;(function (angular) {
  'use strict'

  angular
    .module('kilo.routes.quote.list', [])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = ['$stateProvider']

  function RouteConfigurator ($stateProvider) {
    var showState = {
      name: 'quote.list',
      url: '/list',
      // Retire le watcher $rootScope de la pagination résolue par cet état à sa sortie
      onExit: ['pagination', function (pagination) { pagination.destroy() }],
      title: 'DEVIS',
      resolve: {
        pagination: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('quoteList')
        }],
        customFields: ['CustomFieldManager', function (CustomFieldManager) {
          return CustomFieldManager.get(CustomFieldManager.query().select('quote', 'model'))
            .then(function (data) {
              return data.data
            })
        }],
        linkedSearch: [ '$stateParams', function ($stateParams) {
          return $stateParams.linkedSearch
        } ],
        referers: ['UserManager', function (UserManager) {
          return UserManager.getReferers().then(function (data) {
            return data.data
          })
        }]
      },
      params: {
        linkedSearch: {}
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/quote/list/templates/quote-list.template.html',
          controller: 'QuoteListController',
          controllerAs: 'list'
        },
        'toolbar@': {
          templateUrl: '/app/modules/quote/list/templates/quote-list-toolbar.template.html',
          controller: 'QuoteListToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: 'Devis'
      }
    }
    $stateProvider
      .state(showState)
  }
})(window.angular)
